@import '../../react-web-ui/assets/styles/mixins';
@import '../../react-web-ui/assets/styles/variables';

.powered-by {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: -20px -20px 10px;
  padding: 10px 20px;
  background-color: $accent-color;
  color: $white;
  font-size: rem(12px);
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
}
